import type { Context } from "hono";

import { lookupRuntimeAuthUser, type RuntimeAuthUser } from "./better-auth-identity.js";
import {
  NODE_PROXY_DELEGATED_USER_ID_HEADER,
  verifyNodeProxyRequestSignature,
} from "./server-node-proxy-signature.js";

export async function resolveDelegatedNodeProxyUser(
  db: unknown,
  c: Context,
): Promise<RuntimeAuthUser | null> {
  if (!db || c.req.header("X-Gencow-Node-Proxy") !== "v1") return null;

  const nodeId = process.env.GENCOW_NODE_ID?.trim();
  const keyId = process.env.GENCOW_NODE_PROXY_KEY_ID?.trim();
  const secret = process.env.GENCOW_NODE_PROXY_SECRET?.trim();
  const delegatedUserId = c.req.header(NODE_PROXY_DELEGATED_USER_ID_HEADER)?.trim();
  const originalHost = c.req.header("X-Gencow-Original-Host")?.trim();
  const originalPath = c.req.header("X-Gencow-Original-Path")?.trim();
  if (!nodeId || !keyId || !secret || !delegatedUserId || !originalHost || !originalPath) return null;

  let actualPath: string;
  try {
    const url = new URL(c.req.url);
    actualPath = `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
  if (actualPath !== originalPath) return null;

  const verifyResult = verifyNodeProxyRequestSignature({
    headers: c.req.raw.headers,
    method: c.req.method,
    originalHost,
    originalPath,
    targetNode: nodeId,
    secretsByKeyId: { [keyId]: secret },
  });
  if (!verifyResult.ok) return null;

  try {
    return await lookupRuntimeAuthUser(db, delegatedUserId);
  } catch {
    return null;
  }
}
